import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useSwitchDetailGeneralInfo } from './hook';
import { SwitchProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import FeedIcon from '@mui/icons-material/Feed';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import dayjs from 'dayjs';

export const SwitchDetailGeneralInfo = ({ switchDetail }: SwitchProps) => {
    const { formik } = useSwitchDetailGeneralInfo(switchDetail);

    return (
        <Accordion
            title="INFORMACIÓN GENERAL"
            icon={<FeedIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Call ID:"
                        name="callId"
                        size="small"
                        value={formik.values.callId}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Canal:"
                        name="channel"
                        size="small"
                        value={formik.values.channel}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipificación 1:"
                        name="typification1"
                        size="small"
                        value={formik.values.typification1}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipificación 2:"
                        name="typification2"
                        size="small"
                        value={formik.values.typification2}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Funcionario:"
                        name="official"
                        size="small"
                        value={formik.values.official}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="EXT:"
                        name="ext"
                        size="small"
                        value={formik.values.ext}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Observaciones:"
                        name="observation"
                        size="small"
                        value={formik.values.observation}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Creado por:"
                        name="userCreate"
                        size="small"
                        value={formik.values.createdBy}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de creación"
                        name="createAt"
                        size="small"
                        value={dayjs(formik.values.created_at).subtract(
                            5,
                            'hours'
                        )}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Modificado por"
                        name="createdBy"
                        size="small"
                        value={formik.values.updatedBy}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de modificación"
                        name="createdAt"
                        size="small"
                        value={dayjs(switchDetail?.updated_at).subtract(5, 'h')}
                        disabled
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
